import { useEffect, useRef, useState } from 'react';
import { sampleScene } from '../Utils/scenePerf';

const emptySnap = {
  fps: 0,
  frameMs: 0,
  fpsHistory: [],
  calls: 0,
  triangles: 0,
  renderPoints: 0,
  renderLines: 0,
  geometries: 0,
  textures: 0,
  programs: 0,
  meshes: 0,
  points: 0,
  instanced: 0,
  lines: 0,
  objects: 0,
  visibleObjects: 0,
  gpuBytes: 0,
  vertices: 0,
  instances: 0,
  pointCount: 0,
  layerRows: [],
  layers: {
    catalogue: 0,
    visible: 0,
    loading: 0,
    ready: 0,
    failed: 0,
    hiddenReady: 0,
  },
  heap: null,
  deviceMemory: null,
  ready: false,
};

/**
 * Live renderer / scene samples while the scene data panel is open.
 * FPS is measured from animation frames; GPU stats come from the last Three.js render.
 */
export function useScenePerf({ enabled, three, layerVisibility }) {
  const [snap, setSnap] = useState(emptySnap);
  const threeRef = useRef(three);
  const visRef = useRef(layerVisibility);
  threeRef.current = three;
  visRef.current = layerVisibility;

  useEffect(() => {
    if (!enabled) {
      setSnap(emptySnap);
      return undefined;
    }

    let raf = 0;
    let frames = 0;
    let lastStamp = performance.now();
    const fpsHistory = [];

    const tick = (now) => {
      frames += 1;
      const elapsed = now - lastStamp;
      if (elapsed >= 400) {
        const fps = (frames * 1000) / elapsed;
        const frameMs = elapsed / frames;
        frames = 0;
        lastStamp = now;
        fpsHistory.push(fps);
        if (fpsHistory.length > 40) fpsHistory.shift();
        const sceneSnap = sampleScene(threeRef.current, visRef.current);
        setSnap({
          ...sceneSnap,
          fps,
          frameMs,
          fpsHistory: fpsHistory.slice(),
        });
      }
      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [enabled]);

  return snap;
}
